export default __webpack_public_path__ + "static/media/nrutyam2.a0eef5a2.jpeg";